import { createContext, useContext, useMemo, useState } from "react";
import { setLocale } from "react-i18nify";

const LanguageContext = createContext<LanguageContextProps>({
    language: "en",
    setLanguage: () => {}
});

export const LanguageProvider = ({ language = "en", children }: LanguageContextProps): JSX.Element => {
    const [lang, setLanguage] = useState(language);

    const handleSetLanguage = (l: "en" | "es"): void => {
        setLocale(l);
        setLanguage(l);
    };

    const context = useMemo(() => {
        return {
            setLanguage: handleSetLanguage,
            language: lang
        };
    }, [lang]);

    return <LanguageContext.Provider value={context}>{children}</LanguageContext.Provider>;
};

export const useLanguage = (): LanguageContextProps => {
    return useContext(LanguageContext);
};

interface LanguageContextProps {
    language?: string;
    setLanguage?: (l: "en" | "es") => void;
    children?: React.ReactNode;
}
